module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-project-list",
    attrs: {
      "id": "section-project-list"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('gallery-dynamix')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "display": "none"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("web works")]), _vm._v(" "), _c('ul', _vm._l((_vm.workList), function(work) {
    return _c('li', {
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('a', {
      attrs: {
        "href": work.link,
        "target": "_blank"
      }
    }, [_c('h2', {
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_vm._v(_vm._s(work.name))]), _vm._v(" "), _c('img', {
      staticStyle: {
        "max-width": "240px",
        "padding": "15px",
        "border-radius": "3px",
        "background-color": "rgba(255,255,255,0.7)"
      },
      attrs: {
        "src": work.logo,
        "data-pin-nopin": "true"
      }
    })])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786225ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentProjectListSection.vue
// module id = 828
// module chunks = 1